module.exports = __webpack_public_path__ + "img/homepage_bg2.4e3210f1.png";